import React, { useEffect, useMemo, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { FileList, FileUploadBox } from "@components";
import { Input, Radio, TextArea } from "@components/form";
import { post, put } from "@utils/axios_api";
import { useQueryClient } from '@tanstack/react-query';
function ReferenceForm({ selectedData, onSaved, onAdd }) {

    const [atchFileId, setAtchFileId]   = useState("");
    const [originFileCnt, setOriginFileCnt] = useState(0);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [deletedFileSns, setDeletedFileSns] = useState([]);
    const maxFileCount = 1;

    const defaultFormValues = useMemo(() => ({
        title: "",
        content: "",
        useYn: "Y",
        atchFileId: "",
    }),[]);

  const methods = useForm({
    defaultValues: defaultFormValues, // defaultValues : react-hook-form 초기값 설정 옵션
  });

  const { reset, handleSubmit} = methods;
  const isEdit = useMemo(() => !!selectedData, [selectedData]); // 수정 모드, 등록 모드 판별
  const queryClient = useQueryClient();


  // 목록에서 선택한 값 세팅
  useEffect(() => {
    if (isEdit) {
      reset(selectedData);
      setAtchFileId(selectedData.atchFileId || "");
      setDeletedFileSns([]);
      setSelectedFiles([]);
    } else {
      reset(defaultFormValues);
      setAtchFileId("");
      setDeletedFileSns([]);
      setSelectedFiles([]);
    }
  }, [isEdit, selectedData, reset, defaultFormValues]);


  const markDelete = (file) => setDeletedFileSns((prev) => [...prev, file.fileSn]);

  const remainExistingCnt = originFileCnt - deletedFileSns.length;


  const handleAdd = () => {
    reset(defaultFormValues);
    setAtchFileId("");
    setSelectedFiles([]);
    setDeletedFileSns([]);
    onAdd && onAdd();
  };

const onSubmit = async (formData) => {
  try {
    const fd = new FormData();
    fd.append("title", formData.title);
    fd.append("content", formData.content);
    fd.append("useYn", formData.useYn || "Y");
    // 기존 그룹이 있으면 그대로, 없으면 빈 문자열
    fd.append("atchFileId", atchFileId || "");

    // 새로 선택한 파일들(단일 업로드라 배열 길이 0 또는 1) 
    selectedFiles.forEach((file) => fd.append("files", file));

    // 삭제 표시된 파일 SN => 배열 형태로 전송 
    deletedFileSns.forEach((sn) => fd.append("deletedFileSns", sn));

    const url = isEdit ? `/admin/ref/saveRef/${selectedData.referenceId}` : "/admin/ref/saveRef";
    const api = isEdit ? put : post;
    const res = await api(url, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    // 서버가 새 atchFileId 를 돌려주는 경우(신규 등록) 상태 갱신
    if (!atchFileId && res?.result?.atchFileId) {
      setAtchFileId(res.result.atchFileId);
    }

    alert(res?.message || "저장되었습니다.");
    await queryClient.invalidateQueries({ queryKey: ["selectReferenceList"] });
    await queryClient.invalidateQueries({ queryKey: ["fileDetails"] });

    handleAdd();

  } catch (err) {
    const msg = err.response?.data?.message || err.message;
      console.log(msg);
    }
};


  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} >
        <div className="section-tit-wrap">
            <h3 className="border-left-primary">&nbsp;자료실 등록/수정</h3>
            <div className="btn-right-box">
            <ul>
                <li><button type="button" title="추가" className="btn-add" onClick={handleAdd}>추가</button></li>
                <li><button type="submit" title="저장" className="btn-save">저장</button></li>
            </ul>
            </div>
        </div>

        <table className="table-write">
            <colgroup>
            <col style={{ width: "10%" }} />
            <col  />
            </colgroup>
            <tbody>
            <tr>
                <th>제목</th>
                <td>
                <Input
                    name="title"
                    placeholder="제목"
                    className="input-text"
                    style={{ width: "100%" }}
                    />
                </td>
            </tr>
            <tr>
                <th>내용</th>
                <td>
                    <TextArea
                        name="content"
                        className="area"
                        autoResize
                        placeholder="내용"
                    />
                </td>
            </tr> 
            <tr>
              <th>첨부파일</th>
              <td>
                {isEdit &&  (
                  <FileList
                    atchFileId={atchFileId}
                    showDelete={true}
                    className="edit"
                    deletedFileSns={deletedFileSns}
                    onLoaded={setOriginFileCnt}
                    onFileDeleteMark={(file) => {
                      markDelete(file);
                    }}
                  />
                )}

                {/* 파일 업로드 부분 */}
                <div style={{marginLeft:"-12px"}}>
                <FileUploadBox
                  maxFileCount={maxFileCount}
                  selectedFiles={selectedFiles}
                  setSelectedFiles={setSelectedFiles}
                  existingFilesCount={remainExistingCnt}
                  deletedFileSns={deletedFileSns}
                />
                </div>
              </td>
            </tr>
            <tr>
              <th>게시여부</th>
              <td>
              <div style={{display:"flex", gap:"15px"}}>
                <Radio name="useYn" label="게시" value="Y" />
                <Radio name="useYn" label="숨김" value="N" />
              </div>
              </td>
            </tr>

            </tbody>
        </table>
      </form>
    </FormProvider>
  );
}

export default ReferenceForm;
